/* Syrup Oracle: Bar Book card permalinks.
   assets/so-recipe-pages.json maps recipe slugs (metaobject handles AND
   handleized titles) -> standalone /pages/ handles (the 91 rebuilt legacy
   recipe URLs). Each Bar Book card whose slug appears in the map gets a
   small "Recipe page" link in its actions row — a stable, shareable,
   indexable URL per recipe.
   The pass runs several times (idempotent — skips cards already linked):
   the Bar Book page has other scripts (finder, tools) moving nodes around,
   and a single early pass proved unreliable. Progressive enhancement:
   fetch failure -> no links, nothing breaks. */
(function () {
  'use strict';
  var src = document.getElementById('so-recipe-pages-src');
  var url = (src && src.getAttribute('data-src')) || '/assets/so-recipe-pages.json';

  fetch(url, { cache: 'no-cache' }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (map) {
    function pass() {
      document.querySelectorAll('.so-recipe-book .so-recipe[id^="recipe-"]').forEach(function (card) {
        var slug = card.id.replace(/^recipe-/, '');
        var pageHandle = map[slug];
        if (!pageHandle) return;
        var actions = card.querySelector('.so-recipe__actions');
        if (actions && !actions.querySelector('.so-recipe__permalink')) {
          var a = document.createElement('a');
          a.className = 'so-recipe__permalink';
          a.href = '/pages/' + pageHandle;
          a.innerHTML = 'Recipe page &rsaquo;';
          actions.appendChild(a);
        }
        // Client-cloned cards (entries 51+) lose the server-rendered name
        // link — restore it.
        var name = card.querySelector('.so-recipe__name');
        if (name && !name.querySelector('a')) {
          var n = document.createElement('a');
          n.className = 'so-recipe__name-link';
          n.href = '/pages/' + pageHandle;
          n.textContent = name.textContent;
          name.textContent = '';
          name.appendChild(n);
        }
      });
    }
    pass();
    [600, 1500, 3000, 5000].forEach(function (ms) { setTimeout(pass, ms); });
  }).catch(function () { /* progressive enhancement only */ });
})();
